import React from 'react';

import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

Transition.displayName = 'TransitionRef';

export default function ImageDialog({ src, mime, children, open, onClose, ...props }) {
  return <Dialog
    fullScreen={true}
    open={open}
    onClose={onClose}
    TransitionComponent={Transition}
    {...props}
  >
    <AppBar>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>

    {
      React.Children.count(children)
        ? children
        : (
          <object style={
            {
              display: 'block',
              width: '100%',
              height: mime === 'application/pdf'? '100%':'auto'
            }
          } type={mime} data={src}>
            Detalhes
          </object>
        )
    }
  </Dialog>;
}
